<template>
    <a @click="loadDetail" type="button" data-toggle="tooltip" :title="$t('callDetail')" href="javascript:">
        {{$t('callDetail')}}
        <b-modal v-model="showForm" ok-only :title="$t('callDetail')" v-if="call">
          <app-audio  v-if="call.recordingDownloaded" :id="call._id" :duration="call.duration"   />
            <div>
                <p v-if="this.call && this.call.direction">
                    <span class="small">{{ $t('direction') }}: </span><span>{{ $t(this.call.direction) }}</span>
                </p>
            </div>
            <div>
                <h4>{{ $t('from') }}</h4>
                <p v-if="this.call.fromUser">
                    <span class="small">{{ $t('agent') }}: </span><span>{{ this.call.fromUser.name }}</span>
                </p>
                <p v-if="this.call.fromExt">
                    <span class="small">{{ $t('ext') }}: </span><span>{{ this.call.fromExt }}</span>
                </p>
                <p v-if="this.call.fromNumber">
                    <span class="small">{{ $t('number') }}: </span>
                    <span v-if="this.call && this.call.direction !== 'inbound'"><b>{{ this.call.fromNumber }}</b></span>
                    <span v-else><b>{{this.call.fromNumber}}</b></span>
                </p>
            </div>
            <div>
                <h4>{{ $t('to') }}</h4>
                <p v-if="this.call.toNumber">
                    <span class="small">{{ $t('number') }}: </span>
                  <span v-if="this.call && this.call.direction !== 'outbound'"><b>{{ this.call.toNumber }}</b></span>
                    <span v-else><b>{{this.call.toNumber}}</b></span>
                </p>
                <p v-if="this.call.toUser">
                    <span class="small">{{ $t('agent') }}: </span><span>{{ this.call.toUser.name }}</span>
                </p>
                <p v-if="this.call.toExt">
                    <span class="small">{{ $t('ext') }}: </span><span>{{ this.call.toExt }}</span>
                </p>
            </div>
            <div>
                <h4>{{ $t('detail') }}</h4>
                <p v-if="this.call.startTime">
                    <span class="small">{{ $t('startTime') }}: </span><span>{{ this.call.startTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
                </p>
                <p v-if="this.call.answerTime">
                    <span class="small">{{ $t('answerTime') }}: </span><span>{{ this.call.answerTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
                </p>
                <p v-if="this.call.endTime">
                    <span class="small">{{ $t('endTime') }}: </span><span>{{ this.call.endTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
                </p>
                <p v-if="this.call.duration">
                    <span class="small">{{ $t('duration') }}: </span><span>{{ this.call.duration | callDuration }}</span>
                </p>
                <p v-if="this.call.duration && this.call.billDuration">
                    <span class="small">{{ $t('waitingDuration') }}: </span><span>{{ this.call.duration - this.call.billDuration | callDuration }}</span>
                </p>
                <p v-if="this.call.billDuration">
                    <span class="small">{{ $t('billDuration') }}: </span><span>{{ this.call.billDuration | callDuration }}</span>
                </p>
                <p v-if="this.call.hangupCause">
                    <span class="small">{{ $t('hangupCause') }}: </span><span>{{ this.call.hangupCause }}</span>
                </p>
                <p v-if="call.transcripts && call.transcripts.length">
                    <span class="small">{{ $t('content') }}:</span> {{ call.transcripts.join(", ") }}</p>
                <p v-else-if="call.billDuration" class="text-gray-999">{{ $t('noTranscript') }}</p>
                <p v-else class="text-gray-999">{{ $t('fail') }}</p>
            </div>
        </b-modal>
    </a>
</template>
<script>
    import AppAudio from "@/components/AppAudio.vue";
    export default {
        props: ['callId'],
        components: {AppAudio},
        data: function () {
            return {
                call: null,
                showForm: false,
                recordingUrl: null
            }
        },
        methods: {
            loadDetail() {
                this.$service.get('/call/' + this.callId).then(response => {
                    this.call = response.data;
                })
                // this.listen(this.callId);
                this.showForm = true;
            },
            listen(id) {
                this.$service.get(`/call/${id}/recording`).then(response => {
                    this.recordingUrl = response.data.url;
                }).catch(error => {
                    if (error.response.data.message) {
                        this.$swal({
                            text: error.response.data.message,
                            icon: 'error'
                        });
                    }
                })
            },
        },
        mounted() {
        },
        i18n: {
            messages: {
                en: {
                    callDetail: 'Call detail',
                    direction: 'Call type',
                    from: 'Call from',
                    number: 'Phone number',
                    to: 'Call to',
                    detail: 'Detail',
                    startTime: 'Start time',
                    answerTime: 'Answer time',
                    endTime: 'End time',
                    duration: 'Duration',
                    waitingDuration: 'Waiting time',
                    billDuration: 'Talking time',
                    hangupCause: 'Hangup cause',
                    noTranscript: "No transcript",
                    fail: "Connect fail",
                    content: "Content",
                },
                vi: {
                    callDetail: 'Chi tiết cuộc gọi',
                    direction: 'Loại cuộc gọi',
                    from: 'Gọi từ',
                    number: 'SĐT',
                    to: 'Gọi tới',
                    detail: 'Chi tiết',
                    startTime: 'Gọi lúc',
                    answerTime: 'Nghe máy',
                    endTime: 'Kết thúc',
                    duration: 'Thời lượng',
                    waitingDuration: 'Thời gian chờ',
                    billDuration: 'Thời gian đàm thoại',
                    hangupCause: 'Lý do gác máy',
                    noTranscript: "Thiết bị không hỗ trợ AI",
                    fail: "Kết nối thất bại",
                    content: "Nội dụng",
                }
            }
        }
    }
</script>